import { validate } from "../../helpers/validate.js";
import { attributesCodeBlockSchema } from "./attributes.js";
import { guideCodeBlockHtml } from "./component.js";
import { ScalarCodeBlockVue } from "./component.js";
import { parseCodeBlockMeta } from "./helpers.js";
import { defaultHandlers } from "hast-util-to-mdast";
import { nanoid } from "@scalar-org/entities/utility";
import { parseCodeBlockMeta as parseCodeBlockMeta2 } from "../../elements/index.js";
import { withDataAttrFallback } from "../../helpers/attributes-with-data-fallback.js";
import { hydrate } from "./hydration.js";
const scalarCodeBlock = {
  name: "scalar-code",
  tagName: "scalar-code",
  tiptapName: "custom_code_block",
  attributeTransform: (_, _attrs) => {
    const attrs = withDataAttrFallback(_attrs);
    const parsedMeta = typeof attrs.meta === "string" ? parseCodeBlockMeta2(attrs.meta) : {};
    const validated = validate(attributesCodeBlockSchema, {
      ...parsedMeta,
      // ---------------------------------------------------------------------------
      // We consider the presence of the fullHeight attribute, regardless of its value, to
      // indicate that fullHeight is true. This allows for usage like fullHeight="false"
      // to explicitly disable it while still being recognized as true.
      lang: attrs.lang || "plaintext",
      // ---------------------------------------------------------------------------
      // Adding a unique ID to each code block allows us to use the ids when
      // the code blocks are inside a code group
      id: attrs.id || nanoid()
    });
    return validated;
  },
  render: async (props) => {
    return guideCodeBlockHtml(props);
  },
  hydrate,
  markdownHandler: (state, node) => {
    if (node.properties["data-scalar-type"] !== scalarCodeBlock.tagName) {
      return defaultHandlers.pre(state, node);
    }
    const lang = typeof node.properties?.lang === "string" ? node.properties.lang : "";
    [
      "lineNumbers",
      "fullHeight",
      "lineNumberStart",
      "maxHeight",
      "minHeight"
    ].forEach((attr) => {
      const lowerAttr = attr.toLowerCase();
      if (lowerAttr in node.properties) {
        if (["lineNumbers", "fullHeight"].includes(attr)) {
          node.properties[attr] = node.properties[lowerAttr] === "" || node.properties[lowerAttr] === "true";
        } else {
          node.properties[attr] = node.properties[lowerAttr];
        }
      }
    });
    const parsedAttributes = attributesCodeBlockSchema.omit({ lang: true }).partial().parse(node.properties) || {};
    const metaArr = Object.entries(parsedAttributes).map(([key, value]) => {
      if (key === "title") return "";
      if (key === "lineNumbers" || key === "fullHeight") {
        if (value === false) return "";
        return key;
      }
      return `${key}=${value}`;
    });
    if (parsedAttributes.title) metaArr.unshift(parsedAttributes.title);
    const meta = metaArr.filter(Boolean).join(" ");
    const toHtml = (node2) => {
      if (node2.type === "text") {
        return node2.value;
      }
      if (node2.type === "element") {
        const children = node2.children.map(toHtml).join("");
        return `<${node2.tagName}>${children}</${node2.tagName}>`;
      }
      return "";
    };
    return [
      {
        type: "code",
        lang,
        meta,
        value: node.children.map(toHtml).join("")
      }
    ];
  }
};
export {
  ScalarCodeBlockVue,
  parseCodeBlockMeta,
  scalarCodeBlock
};
//# sourceMappingURL=index.js.map
